<template>
  <F360InlineBanner>
    <b>Busque novamente os dados da integração</b> para tentar importar vendas,
    notas ou extratos que não foram processados. Acompanhe o progresso no
    histórico da integração.
  </F360InlineBanner>
</template>

<script setup lang="ts">
import F360InlineBanner from "@/ui/components/Feedback/F360InlineBanner.vue";
</script>
